// Карточка голоса → проба для общего проигрывателя страницы «Озвучка» (useVoicePreview).
import type { VoiceCard } from '../../api/voiceCatalog'
import type { TtsVoice } from '../../pages/generate/utils/ttsVoices'

export function asPreview(v: VoiceCard): TtsVoice {
	return { id: v.id, label: v.name, gender: v.gender, hint: v.hint, sample: v.preview_url }
}
